module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjM5MDM3IDkuMDAwMDVMMC42MDczNjEgMi4yMTcwNEwyLjIxNjk4IDAuNjA3NDIyTDguOTk5OTkgNy4zOTA0M0wxNS43ODMgMC42MDc0MjJMMTcuMzkyNiAyLjIxNzA0TDEwLjYwOTYgOS4wMDAwNUwxNy4zOTI2IDE1Ljc4MzFMMTUuNzgzIDE3LjM5MjdMOC45OTk5OSAxMC42MDk3TDIuMjE2OTggMTcuMzkyN0wwLjYwNzM2MSAxNS43ODMxTDcuMzkwMzcgOS4wMDAwNVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup-close.svg
// module id = OG+S
// module chunks = 1